import { render, staticRenderFns } from "./PackageMthlyStats.vue?vue&type=template&id=973bab58&"
import script from "./PackageMthlyStats.vue?vue&type=script&lang=js&"
export * from "./PackageMthlyStats.vue?vue&type=script&lang=js&"
import style0 from "./PackageMthlyStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageMthlyStats.vue"
export default component.exports